<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<p class="contentsHead">Contents</p>
<p class="toc" style="text-indent: 0em;"><a href="#/part001">Part 1 - April 1996</a></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part002" title="Link target outside of Sample">Part 2 - November</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part003" title="Link target outside of Sample">Part 3 - November 27-December 5</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part004" title="Link target outside of Sample">Part 4 - December 6</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part005" title="Link target outside of Sample">Part 5 - December 8-9</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part006" title="Link target outside of Sample">Part 6 - December 10-23</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part007" title="Link target outside of Sample">Part 7 - Christmas</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part008" title="Link target outside of Sample">Part 8 - Saint Stephen’s Day</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part009" title="Link target outside of Sample">Part 9 - The Price of Miracles December 27</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/part010" title="Link target outside of Sample">Coda April 24, 1997</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7a325a7c